import { styled } from 'styled-components';
import { RootState } from '@src/state/store';

import { _useSelector } from '@src/state/hooks';
import { Stage } from '@src/state/slices/types';

import Login from '@src/components/Login';
import Lobby from '@src/components/Lobby';
import Game from '@src/components/Game';

import Toast from './Toast';

const TOAST_TIMEOUT = 3000;

const Container = styled.div`
  font-family: 'Sanko';
  width: 100%;
  max-height: 100%;
  flex: 1;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;

const renderStage = (stage: Stage) => {
  switch (stage) {
    case Stage.LOGIN:
      return <Login />;
    case Stage.LOBBY:
      return <Lobby />;
    case Stage.SHOW_GAME:
      return <Game />;
    default:
      return <p>error</p>;
  }
};

type AppViewControllerProps = {
  disconnect?: () => void;
};

export default function AppViewController({
  disconnect,
}: AppViewControllerProps) {
  const appStage = _useSelector((state: RootState) => state.app.stage);

  if (!appStage) return <p>error</p>;

  return (
    <Container>
      {appStage !== Stage.SHOW_GAME && (
        <Toast textColor='blue' gameColor={'#a1a1a1'} timeout={TOAST_TIMEOUT} />
      )}
      {renderStage(appStage)}
    </Container>
  );
}
